import { render, staticRenderFns } from "./ShareFacebookButton.vue?vue&type=template&id=9e8c87ba&scoped=true&"
import script from "./ShareFacebookButton.vue?vue&type=script&lang=js&"
export * from "./ShareFacebookButton.vue?vue&type=script&lang=js&"
import style0 from "./ShareFacebookButton.vue?vue&type=style&index=0&id=9e8c87ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../rebuild/huang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8c87ba",
  null
  
)

export default component.exports